import { IconProps } from './icon';

export function PersonIcon({
  size = '100%',
  fill = 'currentColor',
  className,
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 33 32"
      fill="none"
    >
      <path
        d="M15.8509 14.9675C17.9888 14.9675 19.7219 13.2344 19.7219 11.0966C19.7219 8.95868 17.9888 7.22559 15.8509 7.22559C13.7131 7.22559 11.98 8.95868 11.98 11.0966C11.98 13.2344 13.7131 14.9675 15.8509 14.9675Z"
        stroke={fill}
        strokeWidth="1.11864"
      />
      <path
        d="M8.8833 24.258V20.4239L11.7736 17.5483L16.1091 18.9861L20.4446 17.5483L23.3349 20.4239V24.258"
        stroke={fill}
        strokeWidth="1.11864"
      />
    </svg>
  );
}
